import {Fragment} from 'react';
import {Typography} from '@material-tailwind/react';

const AboutUs = () => {
  return (
    <Fragment>
      <div className="w-full min-h-[600px] flex justify-center px-4 lg:px-0">
        <div className="w-full max-w-[1240px] flex flex-col-reverse rounded-[30px] overflow-hidden lg:flex-row">
          <div className='w-full h-full flex flex-col items-center justify-center bg-[#D9D9D9] lg:w-[50%]'>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video autoPlay={true} loop={true} playsInline={true} className="h-[368px] w-[180px] lg:h-[550px] lg:w-[277px]">
              <source
                src="https://res.cloudinary.com/ornamap/video/upload/v1691328125/ornamap-web-landing-video-webm.webm"
                type="video/webm"/>
              <source
                src="https://res.cloudinary.com/ornamap/video/upload/v1691328609/ornamap-web-landing-video-mp4.mp4"
                type="video/mp4"/>
              Sorry, your browser doesn{'\''}t support videos.
            </video>
          </div>

          <div
            className='w-full h-[150px] px-4 bg-[#12A62833] flex items-center justify-center lg:w-[50%] lg:h-full lg:px-0'>
            <Typography
              variant='h3'
              className='max-w-[515px] text-[30px] text-[#282B59] leading-hundred font-black font-nunito lg:text-[55px]'
            >
              What is OrnaMap and how to get started?
            </Typography>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

 export default AboutUs;